@if (venueSection$ | async; as venueSection) {
  <app-seatmap
    [venueSection]="venueSection"
    [selectedVenueSectionSeats]="selectedVenueSectionSeatIds$ | async"
    (venueSectionSeatClick)="onVenueSectionSeatClick($event)"
    [blockades]="blockades"
    [options]="seatMapOptions"
  ></app-seatmap>
}
